"use strict";

exports.__esModule = true;
exports.default = exports.Card = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _excluded = ["tag", "color", "outline", "className", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The Card component is a UI design pattern that groups related information in a flexible-size container.
 * It provides three components to compose its content: the CardHeader, the CardSection and the CardFooter.
 */
var Card = function Card(_ref) {
  var Tag = _ref.tag,
      color = _ref.color,
      outline = _ref.outline,
      className = _ref.className,
      children = _ref.children,
      attributes = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classes = (0, _clsx.default)('uk-card', className, color !== 'default' && color, outline && 'outline');
  return /*#__PURE__*/_react.default.createElement(Tag, _extends({
    className: classes
  }, attributes), children);
};

exports.Card = Card;
Card.propTypes = {
  /**
   * HTML tag used as root tag of the Card
   */
  tag: _propTypes.default.string,

  /**
   * Background-color of the Card (or border-color if outline)
   */
  color: _propTypes.default.oneOf(['default', 'primary', 'secondary', 'success', 'warning', 'alert']),

  /**
   * Invert styling colors of the Card
   */
  outline: _propTypes.default.bool
};
Card.defaultProps = {
  tag: 'article',
  color: 'default',
  outline: false
};
var _default = Card;
exports.default = _default;